'use client';

import { type FC, useEffect, useState } from 'react';

import { getPromoCodes } from '@/services/promo-codes';

import {
    TableModal,
    type TableModalProps,
    type TableProps,
} from '@/components/organisms/TableModal';

const PromoCodesModal: FC<TableModalProps> = ({ ...props }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [tableData, setTableData] = useState<TableProps | undefined>(
        undefined,
    );

    useEffect(() => {
        getPromoCodes().then(({ promoCodesData }) => {
            setTableData(promoCodesData);
            setIsLoading(false);
        });
    }, []);

    return (
        <TableModal
            {...props}
            isLoading={isLoading}
            tableData={tableData}
        />
    );
};

export default PromoCodesModal;
